import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';

// WEB SOCKETS
@Injectable()
export class WebsocketService {
  private websocketUrl = environment.controlWebSocketUrl;

  constructor() { }

  public connectV2<TYPE>(): WebSocketSubject<TYPE> {
    return this.connect('/emulator/v2');
  }

  public connectV3<TYPE>(): WebSocketSubject<TYPE> {
    return this.connect('/emulator/v3');
  }

  public connect<TYPE>(path: string): WebSocketSubject<TYPE> {
    return this.getWebsocketConnection<TYPE>(path);
  }

  private getWebsocketConnection<TYPE>(path: string): WebSocketSubject<TYPE> {
    const websocketUrlVersion = this.websocketUrl + path;

    return webSocket({
      url: websocketUrlVersion,
      closeObserver: {
        next: (closeEvent) => {
          // http call to remove session data here.
        },
      },
      openObserver: {
        next: (event) => {
          console.log('emulator websocket connection established: ' + websocketUrlVersion);
        },
      },
    });
  }


}